<script setup>
import { ref, onMounted, computed, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
const router = useRoute();
import axios from "axios";
import { useStore } from 'vuex';
const store = useStore();
const productId = computed(() => store.getters.getProductId);
const guid = computed(() => store.getters.getGuid);
const qq = computed(() => store.getters.getQq);
const follows = ref([]);
const solved = ref(-1);
const imageList = ref([]);
const fileList = ref([]);
const fileInput = ref(null);
const msgInput = ref(null);
const content = ref('');
const isShowLoading = ref(false);
const feedback = router.query;
const showWaitTips = computed(() => {
  if (follows.value.length === 0) {
    return true;
  } else if (follows.value[follows.value.length - 1].type === 'mine') {
    return true;
  }
  return false;
});

const originalHeight = window.innerHeight;

onMounted(() => {
  const queryData = {
    productId: productId.value,
    guid: guid.value,
    feedbackId: feedback.id,
  };
  axios.get(`/feedback/${feedback.id}?productId=${productId.value}&guid=${guid.value}`); // 请求了就会把未读置为已读
  axios.get(`/follow`,{ params: queryData }).then(res => {
    if (res.data && res.data.content) {
      res.data.content.forEach(item => {
        item.createTime = (new Date(item.createTime)).toLocaleDateString()
            .replace(/\//gi, '-');
        item.type = item.type === 1 ? 'admin' : 'mine';
      });
      follows.value = res.data.content;
      console.log('feedback follows', res.data);
    } else {
      console.error('Invalid response data:', res.data);
    }
  }).catch(err => {
    console.log(err);
  });

  if (feedback.solveStatus === '1') {
    solved.value = 1;
  }
});

const solve = (isSolved) => {
  if (!isSolved) {
    console.log('unsolved')
    solved.value = 0;
    return;
  }

  const queryData = {
    productId: productId.value,
    guid: guid.value,
    solveStatus: 1,
  };
  axios.put(`/feedback/${feedback.id}`,queryData ).then(res => {
    if (res.data && res.data.msg && res.data.msg === 'success') {
      solved.value = 1;
    }
  }).catch(err => {
    console.log(err);
  });
}

const deleteImage = (index) => {
  imageList.value.splice(index, 1);
  fileList.value.splice(index, 1);
};

const triggerFileInput = () => {
  fileInput.value.click();
};

const handleFileChange = (event) => {
  const maxSize = 10 * 1024 * 1024;
  const files = Array.from(event.target.files);
  const newImages = files.filter(file => file.size <= maxSize).map(file => URL.createObjectURL(file));
  const newFiles = files.filter(file => file.size <= maxSize);
  if (newImages.length < files.length) {
    window.showToast({ message: '单张图片大小超过限制（10MB），请重新上传' });
  }

  const totalImages = imageList.value.length + newImages.length;

  if (totalImages > 8) {
    const allowedNewImages = 8 - imageList.value.length;
    const truncatedImages = newImages.slice(0, allowedNewImages);
    const truncatedFiles = newFiles.slice(0, allowedNewImages);
    imageList.value = [...imageList.value, ...truncatedImages];
    fileList.value = [...fileList.value, ...truncatedFiles];
    window.showToast({ message: '最多上传8张图片', timeout: 3000 });
  } else {
    imageList.value = [...imageList.value, ...newImages];
    fileList.value = [...fileList.value, ...newFiles];
  }

  event.target.value = ''; // Reset file input
};

const submitForm = async () => {
  if (content.value.trim().length < 8) {
    window.showToast({ message: '请详细描述问题，不低于8个字' });
    msgInput.value.blur();
    return;
  }
  if (content.value.trim().length > 140) {
    window.showToast({ message: '请简要描述问题，不超过140个字' });
    msgInput.value.blur();
    return;
  }

  msgInput.value.blur();
  isShowLoading.value = true;
  const formData = new FormData();
  fileList.value.forEach((file, index) => {
    formData.append(`images[${index}]`, file);
  });
  formData.append('productId', computed(() => store.getters.getProductId).value);
  formData.append('feedbackId', feedback.id);
  formData.append('guid', computed(() => store.getters.getGuid).value);
  formData.append('content', content.value);
  axios.post('/follow', formData).then(res => {
    isShowLoading.value = false;
    if (res.data && res.data.result !== undefined && res.data.result === 0) {
      follows.value.push({
        content: content.value,
        createTime: new Date().toLocaleDateString()
            .replace(/\//gi, '-'),
        type: 'mine',
      });
      fileList.value.length = 0;
      imageList.value.length = 0;
      content.value = '';
    } else {
      window.showToast({ message: '网络繁忙，请稍后再试' });
    }
  }).catch(err => {
    isShowLoading.value = false;
    console.log(err);
    window.showToast({ message: '提交反馈失败，请稍后再试' });
  });
};
const onInput = () => {
  console.log('----focus', document.body.scrollHeight);
  window.scrollTo(0, document.body.scrollHeight);
}
</script>

<template>
  <div class="main-container">
    <div class="chat-window">
      <div class="time">{{ feedback.createTime }}</div>
      <div class="message mine">
        <div class="bubble">{{ feedback.content }}</div>
      </div>
      <template v-for="(message, index) in follows" :key="index">
        <div class="time">{{ message.createTime }}</div>
        <div class="message" :class="message.type">{{ message.content }}</div>
        <div v-if="index === follows.length - 1 && message.type === 'admin'" class="feedback">
          <div class="btn-container" v-if="solved === -1">
            <button class="btn" @click="solve(true)"><img src="../assets/good.png" alt="" class="icon">已解决</button>
            <div class="divider"></div>
            <button class="btn" @click="solve(false)"><img src="../assets/bad.png" alt="" class="icon">未解决</button>
          </div>
          <div class="btn-container" v-else-if="solved === 1">
            <button class="btn-solved"><img src="../assets/good2.png" alt="" class="icon">已解决</button>
          </div>
          <div class="btn-container" v-else-if="solved === 0">
            <button class="btn-unsolved"><img src="../assets/bad2.png" alt="" class="icon">未解决</button>
          </div>
        </div>
      </template>

      <div class="message admin" v-if="solved === 1">太棒了，很高兴能解决您的问题！</div>
      <div class="message admin" v-else-if="solved === 0">抱歉未能解决您的问题，您可以继续反馈。</div>

      <template v-if="showWaitTips">
        <div class="time">{{ feedback.createTime }}</div>
        <div class="message admin"><p>已收到您的反馈。我们会尽快核实并处理您的问题，请耐心等待我们的答复。</p>
          <div class="ref"><b>温馨提示：</b><br/>
            如您已上传图片，为了保护您的个人隐私以及遵守平台的合规要求，图片将不会在对话框中直接展示。请放心，我们已收到您的图片，处理结果会及时与您沟通。</div>
        </div>
      </template>
    </div>
    <div class="bottom-box" :class="imageList.length > 0 ? 'high' : 'short'">
      <div class="photos" v-if="imageList.length > 0">
        <div class="photo" v-for="(image, index) in imageList" :key="index">
          <img :src="image" class="image-thumbnail" alt=""/>
          <div class="delete-button" @click="deleteImage(index)"></div>
        </div>
      </div>
      <div class="input-box">
        <input class="msg-input" type="text" v-model="content" ref="msgInput" placeholder="我想继续提问" enterkeyhint="send" @focus="onInput" @keyup.enter="submitForm">
        <div class="pic-input" @click="triggerFileInput">
          <input type="file" accept=".jpg, .jpeg, .png" ref="fileInput" @change="handleFileChange" multiple style="display: none;" />
        </div>
      </div>
    </div>
    <div v-if="isShowLoading">
      <div class="overlay"></div>
      <div class="loading-box">
        <img src="../assets/loading.png" class="loading-icon" alt=""/>
        <p class="loading-text">正在提交...</p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~/entries/index/index.scss';
.main-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.chat-window {
  display: flex;
  flex-direction: column;
  flex: 1;
  background: rgba(245, 248, 253, 1);
  margin: 0;
  padding: 40*$px 40*$px 262*$px 40*$px;
  box-sizing: border-box;
}

.time {
  align-self: center;
  font-size: 20*$px;
  line-height: 28*$px;
  color: #888888;
  margin-bottom: 20*$px;
}

.message {
  max-width: 75%;
  padding: 32*$px;
  font-size: 28*$px;
  line-height: 42*$px;
  white-space: pre-wrap;
  word-break: break-all;
  margin-bottom: 20*$px;
}

.message.admin .ref {
  background: rgba(245, 248, 253, 1);
  color: rgba(136, 136, 136, 1);
  padding: 20*$px;
  border-radius: 14*$px;
  font-size: 20*$px;
  line-height: 28*$px;
}

.message.mine {
  align-self: flex-end;
  background-color: rgba(231, 235, 255, 1);
  border-radius: 14*$px 0 14*$px 14*$px;
}

.message.admin {
  align-self: flex-start;
  background-color: white;
  border-radius: 0 14*$px 14*$px 14*$px;
}

.feedback {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20*$px;
  padding-right: 105*$px;
}

.btn-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 20*$px;
  height: 60*$px;
  overflow: hidden;
  background-color: white;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5*$px 15*$px;
  border: none;
  background-color: transparent;
  color: rgba(102, 102, 102, 1);
  font-size: 22 * $px;
  line-height: 33 * $px;
}

.btn-solved {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5*$px 15*$px;
  border: none;
  background-color: transparent;
  color: rgba(75, 106, 255, 1);
  font-size: 22 * $px;
  line-height: 33 * $px;
}

.btn-unsolved {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5*$px 15*$px;
  border: none;
  background-color: transparent;
  color: rgba(245, 141, 41, 1);
  font-size: 22 * $px;
  line-height: 33 * $px;
}

.divider {
  width: 1*$px;
  height: 27*$px;
  background-color: rgba(226, 226, 226, 1);
}

.icon {
  width: 32 * $px;
  height: 32 * $px;
}

.high {
  height: 262 * $px;
}

.short {
  height: 118 * $px;
}

.bottom-box {
  margin: 0;
  background: #fff;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;

  .photos {
    display: flex;
    overflow-x: auto;
    flex-wrap: nowrap;
    height: 146 * $px;

    .photo {
      position: relative;
      width: 120 * $px;
      height: 122 * $px;
      margin-top: 24 * $px;
      margin-left: 10 * $px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;

      .image-thumbnail {
        width: 120 * $px;
        height: 120 * $px;
        object-fit: contain;
        border: 1*$px solid rgba(231, 231, 231, 1);
        border-radius: 14*$px;
      }
      .delete-button {
        position: absolute;
        top: 5*$px;
        right: 5*$px;
        background-image: url("../assets/x.png");
        background-size: cover;
        border: none;
        border-radius: 50%;
        width: 28*$px;
        height: 28*$px;
        display: flex;
      }

    }
  }
  .input-box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 118*$px;
    margin: 0;
    padding: 0 20*$px;

    .msg-input {
      height: 70 * $px;
      width: 590 * $px;
      padding: 0 30*$px;
      border: none;
      border-radius: 45*$px;
      box-shadow: none;
      background: rgba(245, 248, 253, 1);
      font-size: 28 * $px;
      line-height: 42 * $px;
      outline: none;
    }
    .msg-input::placeholder {
      color: #bcbcbc;
    }
    .pic-input {
      background-image: url("../assets/pic.png");
      background-size: cover;
      display: inline-block;
      border: none;
      margin-left: 20*$px;
      width: 42 * $px;
      height: 37 * $px;
    }
  }
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
}
.loading-box {
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  width: 245*$px;
  height: 104*$px;
  border-radius: 14*$px;
}
.loading-icon {
  width: 40*$px;
  height: 40*$px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.loading-text {
  margin-left: 10*$px;
  font-size: 28*$px;
  line-height: 36.4*$px;
}
</style>
